var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuOrari(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M457.93,543.39c-5.52-9.73-8.28-20.59-8.26-31.47V192.19c0-35.45,28.4-64.18,64-64.18s64,28.7,64,64.18v293.17l139.95,139.94c24.89,24.9,24.98,65.16-.18,90.33-24.99,24.99-65.63,24.88-90.33.18l-156.53-156.53c-5.01-4.58-9.29-9.94-12.65-15.89h0ZM513.67,1024c282.77,0,512-229.23,512-512S796.44,0,513.67,0,1.67,229.23,1.67,512c0,282.77,229.23,512,512,512h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOrari);
export default __webpack_public_path__ + "static/media/menu-orari.bbfc41c95ec124bc2594ffcd8c9055fc.svg";
export { ForwardRef as ReactComponent };